import React from 'react';

type BigGradeProps = {
  grade: number;
  isRestaurantReview?: boolean;
};

const BigGrade: React.FC<BigGradeProps> = ({ grade, isRestaurantReview }) => {
  const gradeNumber = grade;

  return (
    <div className={`big-grade ${isRestaurantReview && 'restaurant'}`}>
      <div>
        <span className="big-number">
          <b>{gradeNumber}</b>
        </span>
        <span className="small-number">/6</span>
      </div>
    </div>
  );
};

export default BigGrade;
